import { toCzkMinor } from './money.js';
/** Klic pro polozky bez obchodu (bezny nakup „kdekoli"). */
export const NO_STORE = 'none';
export function storeKey(storeId) {
    return storeId ?? NO_STORE;
}
/** Do kosiku se pocita jen to, co uz opravdu ma. */
export function inBasket(item) {
    return item.status === 'found' || item.status === 'found_other_price';
}
/** Skutecna cena prebiji ocekavanou — proto stav found_other_price existuje. */
function priceOf(item) {
    return item.actualPriceMinor ?? item.expectedPriceMinor;
}
export function tripTotals(items, fx) {
    const byStore = {};
    let czkMinor = 0;
    let partial = false;
    for (const item of items) {
        if (!inBasket(item))
            continue;
        const currency = item.expectedCurrency;
        const price = priceOf(item);
        const key = storeKey(item.storeId);
        // Bez meny nevime, kam to pricist; bez ceny neni co pricitat.
        if (currency === null || price === null) {
            if (currency !== null) {
                const bucket = (byStore[key] ??= { currency, minor: 0, counted: 0, withoutPrice: 0 });
                bucket.withoutPrice += 1;
            }
            partial = true;
            continue;
        }
        const bucket = (byStore[key] ??= { currency, minor: 0, counted: 0, withoutPrice: 0 });
        const line = Math.round(price * item.qty);
        bucket.minor += line;
        bucket.counted += 1;
        const czk = toCzkMinor(line, currency, fx);
        if (czk === null)
            partial = true;
        else
            czkMinor += czk;
    }
    return {
        byStore,
        czkMinor: Object.keys(byStore).length === 0 ? 0 : czkMinor,
        partial,
    };
}
/**
 * Odhad ceny planovaneho nakupu: vsechno na seznamu krome nenalezeneho.
 * Na rozdil od tripTotals nezalezi na tom, co uz je v kosiku.
 */
export function planEstimate(items, fx) {
    const byCurrency = {};
    let czkMinor = 0;
    let convertible = true;
    let withoutPrice = 0;
    for (const item of items) {
        if (item.status === 'not_found')
            continue;
        const price = priceOf(item);
        const currency = item.expectedCurrency;
        if (price === null || currency === null) {
            withoutPrice += 1;
            continue;
        }
        const line = Math.round(price * item.qty);
        byCurrency[currency] = (byCurrency[currency] ?? 0) + line;
        const czk = toCzkMinor(line, currency, fx);
        if (czk === null)
            convertible = false;
        else
            czkMinor += czk;
    }
    const any = Object.keys(byCurrency).length > 0;
    return { byCurrency, czkMinor: any && convertible ? czkMinor : null, withoutPrice };
}
//# sourceMappingURL=totals.js.map